import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getI18nTranslationLoadPath, I18N_SUPPORTED_LANGUAGE_CODES } from "./utils/i18nHttpBackend";
import translationManifest from "./generated/i18nVersion.json";

const isTestEnv = process.env.NODE_ENV === "test";
const i18nDebugEnabled = process.env.REACT_APP_I18N_DEBUG === "true";
const hasReactI18nextPlugin =
  typeof initReactI18next === "function" ||
  (typeof initReactI18next === "object" && initReactI18next !== null);

let configuredI18n = i18n;

if (!isTestEnv) {
  configuredI18n = configuredI18n
    .use(HttpApi) // para cargar archivos JSON
    .use(LanguageDetector); // detecta idioma del navegador
}

if (hasReactI18nextPlugin) {
  configuredI18n = configuredI18n.use(initReactI18next); // conecta con React
}

configuredI18n.init({
    fallbackLng: "es",
    lng: isTestEnv ? "es" : undefined,
    supportedLngs: [...I18N_SUPPORTED_LANGUAGE_CODES],
    nonExplicitSupportedLngs: true,
    // Carpetas en public/locales son en, es, etc.; sin esto se pide en-US / es-ES (404 -> HTML en SPA -> sin traducciones).
    load: "languageOnly",
    debug: i18nDebugEnabled,
    saveMissing: false,
    returnNull: false,
    returnEmptyString: false,
    missingKeyNoValueFallbackToKey: true,
    parseMissingKeyHandler: (key) => key,
    defaultNS: "translation",
    ns: ["translation"],
    resources: isTestEnv ? { es: { translation: {} } } : undefined,
    // En UI preferimos NO depender de Suspense para traducciones (y en tests evita renders en blanco)
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
    backend: isTestEnv
      ? undefined
      : {
          // Content-addressed query prevents an older HTTP/SW cache entry from
          // serving a previous release's dictionary to the new application.
          loadPath: getI18nTranslationLoadPath(process.env.PUBLIC_URL || '', translationManifest.version),
        },
  });

export default i18n;
